import { publicConstants } from '../../constants';
import { ActionManagerInstance } from '../../actions/manager';
import ActionsSequencer from '../../actions/sequencer';
import type { Action } from '../../store/state/state-manager';
import * as actions from '../../store/state/actions/action-creators';
import * as actionType from '../../store/state/actions';
import type { SubmitEmbedDataAction, OpenEmbeddedDataModalOptions } from '../open-embedded-data-modal/types';
import { isContextDirty } from '../../store/state/middlewares/property-change-middleware';

export const handleFormInvalid = (actionMgrID: string | number, context: string) => {
  const error = { type: publicConstants.SUBMISSION_FAILURE_TYPE.FORM_VALIDATION_ERROR };
  ActionManagerInstance.rejectActionByID(actionMgrID, true, error);
  ActionsSequencer.handleDeferredActionCompletion(context);
};

export const handleFormContextDirty = (actionsOut: Action[], context: string, containerItemID: string) => {
  const isFormContextDirty = isContextDirty(context);
  if (isFormContextDirty) {
    actionsOut.push(
      actions.postProcess(actions.removeContainerItem, {
        containerItemID,
        skipReleaseLockRequest: true
      })
    );
  }
};

export const createOpenEmbeddedDataModal = ({
  itemData,
  workareaContainerData,
  subscriptData,
  pageGroupName,
  activeWorkArea,
  subscriptFieldName,
  actionMgrID,
  containerItemID
}: OpenEmbeddedDataModalOptions): SubmitEmbedDataAction => {
  const openEmbeddedDataModelActionInfo = {
    referenceList: itemData?.referenceList,
    ID: workareaContainerData?.caseInfo?.ID,
    index: subscriptData[subscriptFieldName],
    containerName: publicConstants.MODAL,
    pageReference: publicConstants.CASE_INFO.CASE_INFO_CONTENT,
    viewID: publicConstants.VIEW_NAMES.DATA_OBJECT_CREATE_VIEW,
    skipSemanticUrl: true,
    actionType: publicConstants.RESOURCE_STATUS.CREATE,
    interestPage: `.${pageGroupName}.${subscriptData[subscriptFieldName] ?? ''}`,
    targetProperty: `.${pageGroupName ?? ''}`,
    pageGroupName,
    context: activeWorkArea ?? '',
    subscriptFieldName
  };
  return {
    type: actionType.OPEN_EMBEDDED_DATA_MODAL,
    payload: {
      isInCreateStage: false,
      isModalAction: true,
      parentContext: '',
      target: '',
      ...openEmbeddedDataModelActionInfo,
      actionMgrID,
      containerItemID,
      doDeleteCaseSummary: false,
      isFormValid: true
    }
  };
};
